import fpApiUtil from "./fp-api-util";

const BASE = "factoryplan/master/route/routes";

const ROUTE_GROUP = "factoryplan/master/route/routegroups";

const getAll = (params) => fpApiUtil.postParams(BASE, params);
const upsert = (changes) => fpApiUtil.postChanges(`${BASE}/save`, changes);
const remove = (changes) => fpApiUtil.postChanges(`${BASE}/delete`, changes);
const getRouteGroups = (params) => fpApiUtil.postParams(ROUTE_GROUP, params);
const saveRouteGroups = (changes) => fpApiUtil.postChanges(`${ROUTE_GROUP}/save`, changes);
const removeRouteGroups = (changes) => fpApiUtil.postChanges(`${ROUTE_GROUP}/delete`, changes);

const fpRouteService = { getAll, upsert, remove, getRouteGroups, saveRouteGroups, removeRouteGroups };
export default fpRouteService;
